import React from 'react'
import { CLIP_PATH_URL } from '../helpers/constants'

type RenderComponentProps = {
	x: number,
	y: number,
	width: number,
	height: number,
}

export type Props = {
	mapObjectId: string,
	visibleToStudents: boolean,
	component: RenderComponentProps => React$Node,
	centeredX: number,
	centeredY: number,
	sizes: [number, number],
	viewX: number,
	viewY: number,
}

export default function MapObject({
	component: Component,
	mapObjectId,
	visibleToStudents,
	sizes,
	centeredX,
	centeredY,
	viewX,
	viewY,
}: Props): React$Node {
	return (
		<g clipPath={CLIP_PATH_URL}>
			<Component
				pointerEvents="none"
				x={centeredX}
				y={centeredY}
				width={sizes[0]}
				height={sizes[1]}
				style={{ opacity: visibleToStudents ? 1 : 0 }}
			/>
		</g>
	)
}
